module.exports = __webpack_public_path__ + "img/radio-button-on.7f31262e.svg";